// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"p3-z","disabled":"q3-z","seeAllAnswers":"r3-z"};